module.exports = [
  require('./enhance_ability'),
  require('./enlarge_reduce'),
  require('./etherealness'),
  require('./evard_s_black_tentacles'),
]
